import { getPermissions } from "@/helper/collection";
import { authenticationService } from "@/services/AuthenticationService";

export const PopupRoutes = {
  path: "pop-up-pages",
  name: "Popup",
  redirect: "/pop-up-pages/get-popup-pages",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/ReportsContainer/reportsMaster"),
      meta: {},
    },
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/ReportsContainer/reportsMaster"),
      meta: {},
    },
    {
      path: "add-popup-page",
      name: "Add Popup Pages",
      component: () => import("@/components/Pages/add-popup-pages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          209,
          2
        ),
      },
    },
    {
      path: "get-popup-pages",
      name: "View Pop Up Pages",
      component: () => import("@/components/Pages/viewListOfPopUpPages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          210,
          2
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/popUpRoutes.js